import { Tooltip } from '@heroui/react'
import React, { useEffect, useRef, useState } from 'react'

// TruncatedTooltip component that only shows tooltip when text is truncated
export const TruncatedTooltip: React.FC<{
  children: React.ReactElement
  content: string
  className?: string
}> = ({ children, content, className }) => {
  const [isTruncated, setIsTruncated] = useState(false)
  const textRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const checkTruncation = () => {
      if (textRef.current) {
        setIsTruncated(textRef.current.scrollWidth > textRef.current.clientWidth)
      }
    }

    checkTruncation()
    // Re-check on window resize
    window.addEventListener('resize', checkTruncation)

    return () => window.removeEventListener('resize', checkTruncation)
  }, [content])

  return (
    <Tooltip className={className} content={content} isDisabled={!isTruncated}>
      {React.cloneElement(children, { ref: textRef })}
    </Tooltip>
  )
}
